import React from "react";
import { Form, Input } from "antd";
import RadioListInput from "../../../components/survey/RadioListInput";

const RadioListEditor = ({ input, updateInput }) => (
  <div className="flex-1 space-y-4">
    <Form.Item layout="vertical" label="Header titles" className="mb-0">
      <Input.TextArea
        size="large"
        value={
          Array.isArray(input.options)
            ? input.options.join("\n")
            : input.options || ""
        }
        onChange={(e) => updateInput(input.id, "options", e.target.value)}
        placeholder={"Enter one header per line, e.g.:\nStrongly agree\nAgree\nDisagree"}
        rows={4}
        className="rounded-xl"
      />
    </Form.Item>
    <Form.Item layout="vertical" label="Left column titles" className="mb-0">
      <Input.TextArea
        size="large"
        value={
          Array.isArray(input.rowOptions)
            ? input.rowOptions.join("\n")
            : input.rowOptions || ""
        }
        onChange={(e) => updateInput(input.id, "rowOptions", e.target.value)}
        placeholder={"Enter one row title per line, e.g.:\nService\nQuality\nValue"}
        rows={4}
        className="rounded-xl"
      />
    </Form.Item>
  </div>
);

export default RadioListEditor;
